
 



 
 import {fs} from "Config/FsConfig";
 
    import ManageUserGroupMemberSearchParameter from 'Modules/Core/Scripts/AppServiceContract/ManageUserGroupMemberSearchParameter';

    import UserData01 from 'Modules/Core/Scripts/AppServiceContract/UserData01';

    import UserCriteria01 from 'Modules/Core/Scripts/UserCriteria01';

    import GroupUpdateRequest from 'Modules/Core/Scripts/AppServiceContract/GroupUpdateRequest';

    import MemberUpdateRequest from 'Modules/Core/Scripts/AppServiceContract/MemberUpdateRequest';

    import MemberData01 from 'Modules/Core/Scripts/AppServiceContract/MemberData01';

    import UserProfile from 'Modules/Core/Scripts/UserProfile';


    //module ManageUserGroupAppService {
    class ManageUserGroupAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/ManageUserGroupAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/ManageUserGroupAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFind = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/Find`;
    public RouteFind() : string {
        return this.ControllerUrl + "/"+"Find";
    }
    public Find(parameter: ManageUserGroupMemberSearchParameter): JQuery.jqXHR<UserData01[]> {
        return $.ajax({
                url: this.RouteFind(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCount = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/Count`;
    public RouteCount() : string {
        return this.ControllerUrl + "/"+"Count";
    }
    public Count(criteria: UserCriteria01): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCount(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?userUID=${encodeURIComponent(userUID)}
    //public static RouteRemove = (userUID: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/Remove`;
    public RouteRemove(userUID: string) : string {
        return this.ControllerUrl + "/"+"Remove";
    }
    public Remove(userUID: string): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteRemove(userUID),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(userUID),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?userUID=${encodeURIComponent(userUID)}
    //public static RouteLoad = (userUID: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/Load`;
    public RouteLoad(userUID: string) : string {
        return this.ControllerUrl + "/"+"Load";
    }
    public Load(userUID: string): JQuery.jqXHR<UserData01> {
        return $.ajax({
                url: this.RouteLoad(userUID),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(userUID),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteUpdate = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/Update`;
    public RouteUpdate() : string {
        return this.ControllerUrl + "/"+"Update";
    }
    public Update(request: GroupUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteUpdate(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAdd = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/Add`;
    public RouteAdd() : string {
        return this.ControllerUrl + "/"+"Add";
    }
    public Add(request: GroupUpdateRequest): JQuery.jqXHR<string> {
        return $.ajax({
                url: this.RouteAdd(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAddMember = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/AddMember`;
    public RouteAddMember() : string {
        return this.ControllerUrl + "/"+"AddMember";
    }
    public AddMember(request: MemberUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteAddMember(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteRemoveMember = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/RemoveMember`;
    public RouteRemoveMember() : string {
        return this.ControllerUrl + "/"+"RemoveMember";
    }
    public RemoveMember(request: MemberUpdateRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteRemoveMember(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindMember = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/FindMember`;
    public RouteFindMember() : string {
        return this.ControllerUrl + "/"+"FindMember";
    }
    public FindMember(parameter: ManageUserGroupMemberSearchParameter): JQuery.jqXHR<MemberData01[]> {
        return $.ajax({
                url: this.RouteFindMember(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(parameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCountMember = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/CountMember`;
    public RouteCountMember() : string {
        return this.ControllerUrl + "/"+"CountMember";
    }
    public CountMember(criteria: UserCriteria01): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCountMember(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?textInput=${encodeURIComponent(textInput)}
    //public static RouteFindUserAutoCompleteData = (textInput: string) => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/FindUserAutoCompleteData`;
    public RouteFindUserAutoCompleteData(textInput: string) : string {
        return this.ControllerUrl + "/"+"FindUserAutoCompleteData";
    }
    public FindUserAutoCompleteData(textInput: string): JQuery.jqXHR<UserData01[]> {
        return $.ajax({
                url: this.RouteFindUserAutoCompleteData(textInput),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(textInput),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteRetrieveUserProfile = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ManageUserGroupAppService/RetrieveUserProfile`;
    public RouteRetrieveUserProfile() : string {
        return this.ControllerUrl + "/"+"RetrieveUserProfile";
    }
    public RetrieveUserProfile(): JQuery.jqXHR<UserProfile> {
        return $.ajax({
                url: this.RouteRetrieveUserProfile(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default ManageUserGroupAppService;



